import { GeoLocation as ApiGeoLocation } from '../libs/landvoice-api/client';
import { GeoLocation } from '../types/common';

/**
 * Converts API GeoLocation (latitude/longitude) to frontend GeoLocation (lat/lng)
 */
export const convertApiGeoLocationToFrontend = (
  apiGeoLocation: ApiGeoLocation
): GeoLocation => ({
  lat: apiGeoLocation.latitude,
  lng: apiGeoLocation.longitude,
});